import React, { createElement } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  href?: string;
  labelName: string;
  tagName?: string;
  upperCase?: boolean;
  capitalize?: boolean;
  binding?: { [key: string]: string };
  className?: string;
  onClick?: () => void;
  id?: string;
  target?: string;
}

const Label: React.FC<Props> = ({
  binding,
  capitalize,
  className,
  href,
  id,
  labelName,
  onClick,
  tagName = "span",
  target,
  upperCase
}) => {
  const { t } = useTranslation();
  const text = prepareText(t(labelName, binding), {
    capitalize,
    upperCase
  });

  let options: any = {
    dangerouslySetInnerHTML: { __html: text }
  };
  if (id !== undefined) {
    options.id = id;
  }
  if (className !== undefined) {
    options.className = className;
  }
  if (onClick !== undefined) {
    options.onClick = onClick;
  }
  if (href !== undefined) {
    options.href = href;
  }
  if (target !== undefined) {
    options.target = target;
  }
  return createElement(tagName, options);
};

const prepareText = (
  text: string,
  options: { capitalize?: boolean; upperCase?: boolean }
) => {
  if (options.upperCase) {
    return text.toUpperCase();
  }
  if (options.capitalize && text.length > 0) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  return text;
};

export default Label;
